<template>
    <div class="d-sm-none">
        <div class="mobile-footer">
            <p>© 2019. Rubies. Powered by Highstreets MFB</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterMobile"
    }
</script>

<style scoped>

</style>